import React from "react";
import Navbar from "./global-components/navbar-v2";
import PageHeader from "./global-components/page-header";
import Service from "./section-components/service-v5";
import Cta from "./section-components/cta-v10";
import FaqV2 from "./section-components/faq-v2";
import Testimonial from "./section-components/testimonial-v2";
import Brand from "./section-components/brand-v4";
import Case from "./section-components/case";
import Footer from "./global-components/footer-v2";

const ServiceV1 = () => {
  let ServiceObject = {
    serviceHeading:
      "Our Email Marketing Services: Direct, Personalized Communication with Outstanding Results. Segment your email list, design personalized messages, and foster trust and loyalty. Increase conversions, utilize measurable metrics, and reach a broad audience with scalable and automated campaigns. Customized strategies deliver engaging content, drive conversions, and build brand loyalty.",
    servicePointsLoop: [
      "Direct and personalized communication for increased engagement and conversions.",
      "Building trust and loyalty through strong client connections.",
      "Cost-effective with high ROI, driving conversions and sales.",
      "Targeted reach and scalability for broad audience engagement and brand loyalty.",
    ],
    serviceDiv: [
      {
        heading: "Direct and Personalized Communication",
        description: "Direct and Personalized Communication: Foster stronger relationships through direct and personalized email communication.",
      },
      {
        heading: "Enhanced Engagement and Conversions",
        description:
          "Enhanced Engagement and Conversions: Drive engagement and boost conversions with tailored content and compelling calls-to-action.",
      },
      {
        heading: "Trust and Loyalty Building",
        description: "Trust and Loyalty Building: Build trust, loyalty, and repeat purchases through consistent and valuable email interactions.",
      },
      {
        heading: "Targeted Reach and Time Efficiency",
        description:
          "Targeted Reach and Time Efficiency: Reach a broad audience efficiently with scalable and automated email campaigns, saving time and ensuring timely communication.",
      },
    ],
  };
  let workWithUs =
    "We are the experts in direct and personalized email marketing, driving conversions and fostering customer relationships. With scalable automation and targeted strategies, we deliver tailored content to build trust, loyalty, and engagement for your brand.";

  return (
    <div>
      <Navbar />
      <PageHeader headertitle="Email Marketing" />
      <Service serviceDetail={ServiceObject} />
      <Cta workWithUs={workWithUs} />
      <FaqV2 />
      <Testimonial />
      <Brand />
      <Case customclass="case-one case-one__team-page case-one__service-page" />
      <Footer />
    </div>
  );
};

export default ServiceV1;
